import baseScmService from 'services/baseScmService';

const superBatchModuleService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    getSuperBatchModules: build.query({
      query: (superBatchId) => ({
        method: 'GET',
        url: '/super-batch-modules',
        params: { super_batch_id: superBatchId },
      }),
      providesTags: (result, error) => {
        const superBatchModulesTags = result?.data?.map((mm) => ({
          type: 'superBatchModule',
          id: mm.id,
        }));
        return error ? [] : superBatchModulesTags;
      },
    }),
    updateMenteeModuleFields: build.mutation({
      query: ({ moduleType, id, interviewRequired, status }) => ({
        method: 'PUT',
        url: `/super-batch-modules/${id}`,
        body: {
          academy_module_type: moduleType,
          interview_required: interviewRequired,
          status: status,
        },
      }),
      invalidatesTags: (result, error, { id }) => {
        return error ? [] : [{ type: 'superBatchModule', id: id }];
      },
    }),
    createSuperBatchModule: build.mutation({
      query: ({
        academyModuleId,
        academyModuleType,
        beforeModuleId,
        interviewRequired,
        superBatchId,
      }) => ({
        method: 'POST',
        url: `/super-batch-modules/`,
        body: {
          academy_module_id: academyModuleId,
          academy_module_type: academyModuleType,
          before_module_id: beforeModuleId,
          interview_required: interviewRequired,
          super_batch_id: superBatchId,
        },
      }),
      invalidatesTags: (result, error, { id }) => {
        return error ? [] : [{ type: 'superBatchModule', id: id }];
      },
    }),
    bulkReorderSuperBatchModules: build.mutation({
      query: (superBatchModules) => ({
        method: 'PUT',
        url: '/super-batch-modules/bulk-reorder',
        body: {
          data: superBatchModules,
        },
      }),
      invalidatesTags: (result, error, superBatchModules) => {
        const superBatchModulesTags = superBatchModules?.map((mm) => ({
          type: 'superBatchModule',
          id: mm.id,
        }));
        return error ? [] : superBatchModulesTags;
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetSuperBatchModulesQuery,
  useUpdateMenteeModuleFieldsMutation,
  useCreateSuperBatchModuleMutation,
  useBulkReorderSuperBatchModulesMutation,
} = superBatchModuleService;

export default superBatchModuleService;
